/* global customElements, HTMLElement */

class MoreProjects extends HTMLElement {
  connectedCallback () {
    this.fetchProjects()
  }

  get url () {
    return this.getAttribute('url')
  }

  async fetchProjects () {
    if (!this.url) {
      return
    }

    const response = await fetch(this.url)
    const $fragment = document.createRange().createContextualFragment(await response.text())
    this.innerHTML = $fragment.firstElementChild.innerHTML
  }
}

customElements.define('dj-more-projects', MoreProjects)
